<template>
  <section class="project-tree-list-tab">
    <div class="subdivisions-list">
      <table-component :class-name="'subdivisions-list-table'"
                       :column-width="columnWidth"
                       :legend="createLegend()"
                       :columns="columns"
                       :all-checked="allChecked"
                       :clearChecked="clearChecked"
                       @changeCheckbox="checkedRoles = $event"
                       @filterName="filterName"
                       @filterProject="filterProject"
                       @filterPermissions="filterPermissions"
                       @filterOwner="filterOwner"
                       @checkAll="checkAll"
      ></table-component>
    </div>
  </section>
</template>

<script>
  import {mapState, mapMutations, mapGetters} from 'vuex'
  import {tableComponentMixin} from "../../../../mixins/utils/tableComponentMixin";

  export default {
    name: "projectTreeList",
    mixins: [tableComponentMixin],
    data() {
      return {
        // dynamicSection: [],
        //два массива ниже пока не используются
        // subdivisionsQuantity: [],
        // rolesQuantity: [],

        nameUp: true,
        nameDown: true,
        nameActive: false,

        projectsUp: true,
        projectsDown: true,
        projectsActive: false,

        ownerUp: true,
        ownerDown: true,
        ownerActive: false,

        legend: [],
        columnWidth: [(285+285)/1140 * 100, 285/1140 * 100, 285/1140 * 100, 0],
        clearChecked: false,
      }
    },
    computed: {
      ...mapState({
        thisProject: state => state.projects.singleProject,
        roles: state => state.projects.allRoles,
        checkedRolesData: state => state.projects.checkedRoles
      }),
      checkedRoles: {
        get() {
          return this.checkedRolesData
        },
        set(val) {
          this.setCheckedRoles(val)
        }
      },
      allChecked() {
        return this.checkedRoles.length == this.projectsChildren.length && this.checkedRoles.length > 0
      },
      projectsChildren() {
        let dynamicSection = []

        let getSectionData = (arr) => {

          if (this.$route.params.item) {

            for (let i = 0; i < arr.length; i++) {
              if (arr[i].id === Number(this.$route.params.item)) {
                dynamicSection = arr[i].items
                break;
              }
              if (arr[i].items.length > 0) {
                for (let j = 0; j < arr[i].items.length; j++) {
                  if (arr[i].items[j].id === Number(this.$route.params.item)) {
                    dynamicSection = arr[i].items[j].items
                    break;
                  }
                }
              }
              if (arr[i].items.length > 0) {
                getSectionData(arr[i].items)
              }
            }
          } else {
            dynamicSection = this.thisProject.items
          }
        }
        getSectionData(this.thisProject.items)

        return dynamicSection
      },
      columns() {
        this.setDisplayedSectionsInCellProjectTreeField(this.itemsTable)

        return this.itemsTable.map(item => {

          return {
            dblClick: item.id,
            dblClickPrefix: `/project-edit/${this.$route.params.id}/project-item/`,
            item,
            cells: [
              {
                text: {
                  text: item.name,
                  isLink: false,
                  isTrimmed: true,
                  // trimWidth: 10
                  trimWidth: 1
                },
                avatar: {
                  isAvatar: false,
                }
              },
              {
                text: {
                  //переделать когда будут роли
                  text: item.permissions.length,
                  isLink: false,
                },
                avatar: {
                  isAvatar: false,
                }
              },
              {
                text: {
                  text: `${item.items.length}`,
                  isLink: false,
                },
                avatar: {
                  isAvatar: false,
                }
              },
              {
                text: {
                  text: '',
                  isLink: true,
                  linkPrefix: `/project-edit/${this.$route.params.id}/project-item/`,
                  link: item.id

                },
                avatar: {
                  isAvatar: false
                },
                isGear: true
              }
            ]
          }
        })
      },
      itemsTable() {
        let arr = this.projectsChildren.slice();

        if (this.nameActive) {
          arr.sort((a,b) => {
            let nameA = a.name;
            let nameB = b.name;

            if (this.nameDown) {
              if (nameA > nameB) return 1;
              if (nameA < nameB) return -1;
              return 0;
            };

            if (this.nameUp) {
              if (nameA > nameB) return -1;
              if (nameA < nameB) return 1;
              return 0
            }
          })
        };

        if (this.projectsActive) {
          arr.sort((a,b) => {
            let nameA = a.permissions.length;
            let nameB = b.permissions.length;

            if (this.projectsDown) {
              if (nameA > nameB) return 1;
              if (nameA < nameB) return -1;
              return 0;
            };

            if (this.projectsUp) {
              if (nameA > nameB) return -1;
              if (nameA < nameB) return 1;
              return 0
            }
          })
        };

        if (this.ownerActive) {
          arr.sort((a,b) => {
            let nameA = a.items.length
            let nameB = b.items.length

            if (this.ownerDown) {
              if (nameA > nameB) return 1;
              if (nameA < nameB) return -1;
              return 0;
            };

            if (this.ownerUp) {
              if (nameA > nameB) return -1;
              if (nameA < nameB) return 1;
              return 0
            }
          })
        }

        return arr;
      }
    },
    watch: {
      checkedRolesData(val) {
        if (val.length === 0) {
          this.clearChecked = true;
          setTimeout(() => this.clearChecked = false, 100);
        }
      }
    },
    methods: {
      ...mapMutations({
        setCheckedRoles: 'projects/SET_CHECKED_ROLES',
        setDisplayedSectionsInCellProjectTreeField: 'projects/SET_DISPLAYED_SECTIONS_IN_CELL_PROJECT_TREE_FIELD'
      }),
      createLegend() {
        return this.legend = [
          {
            text: this.$t('roles.filters.name'),
            filterMethod: 'filterName',
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false
          },
          {
            text: this.$t('projects.project.sections.role'),
            filterMethod: 'filterProject',
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false
          },
          {
            text: this.$t('projects.project.sections.section'),
            filterMethod: 'filterOwner',
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false
          },

          {
            text: '',
            legendSort: false,
            isGear: true
          }
        ]
      },
      checkAll() {
        if (this.allChecked) {
          this.checkedRoles = [];
        } else {
          this.checkedRoles = this.projectsChildren
        }
      },
      filterName(index) {
        this.copyLegend()
        this.setDefaultLegend();
        this.setActiveFilterLegend(index);

        this.nameActive = true;
        this.projectsActive = false;
        this.permissionActive = false;
        this.ownerActive = false;

        this.projectsUp = true;
        this.projectsDown = true;
        this.permissionUp = true;
        this.permissionDown = true;
        this.ownerUp = true;
        this.ownerDown = true;

        if (this.nameUp && this.nameDown) {
          this.nameDown = true;
          this.nameUp = false;
          this.setLegendDown(index);
          this.setLegendArr();
          return;
        };

        if (this.nameUp) {
          this.nameUp = false;
          this.nameDown = true;
          this.setLegendDown(index);
          this.setLegendArr();
          return;
        };

        if (this.nameDown) {
          this.nameUp = true;
          this.nameDown = false;
          this.setLegendUp(index);
          this.setLegendArr();
        }
      },
      filterProject(index) {
        this.copyLegend()
        this.setDefaultLegend();
        this.setActiveFilterLegend(index);

        this.nameActive = false;
        this.projectsActive = true;
        this.permissionActive = false;
        this.ownerActive = false;

        this.nameUp = true;
        this.nameDown = true;
        this.permissionUp = true;
        this.permissionDown = true;
        this.ownerUp = true;
        this.ownerDown = true;

        if (this.projectsUp && this.projectsDown) {
          this.projectsDown = true;
          this.projectsUp = false;
          this.setLegendDown(index);
          this.setLegendArr();
          return;
        };

        if (this.projectsUp) {
          this.projectsUp = false;
          this.projectsDown = true;
          this.setLegendDown(index);
          this.setLegendArr();
          return;
        };

        if (this.projectsDown) {
          this.projectsUp = true;
          this.projectsDown = false;
          this.setLegendUp(index);
          this.setLegendArr();
        }
      },
      filterOwner(index) {
        this.copyLegend()
        this.setDefaultLegend();
        this.setActiveFilterLegend(index);

        this.nameActive = false;
        this.projectsActive = false;
        this.permissionActive = false;
        this.ownerActive = true;

        this.nameUp = true;
        this.nameDown = true;
        this.projectsUp = true;
        this.projectsDown = true;
        this.permissionUp = true;
        this.permissionDown = true;

        if (this.ownerUp && this.ownerDown) {
          this.ownerDown = true;
          this.ownerUp = false;
          this.setLegendDown(index);
          this.setLegendArr();
          return;
        };

        if (this.ownerUp) {
          this.ownerUp = false;
          this.ownerDown = true;
          this.setLegendDown(index);
          this.setLegendArr();
          return;
        };

        if (this.ownerDown) {
          this.ownerUp = true;
          this.ownerDown = false;
          this.setLegendUp(index);
          this.setLegendArr();
        }
      },
    },
    destroyed() {
      this.checkedRoles = [];
    }
  }
</script>

<style lang="scss" scoped>
  .subdivisions-list-table {
    padding: 20px 0 0;
  }
</style>
